import React from "react";
import {hasValidationMessage} from "./hasValidationMessage";
import {type ValidationError} from "../../../infrastructure/types";

interface ValidationMessageProps {
  errors: ValidationError[];
}

export const ValidationMessage: React.FC<ValidationMessageProps> = ({errors}) => {
  if (!hasValidationMessage(errors)) {
    return null;
  }

  return (
    <>
      {errors
        .filter(error => error.message)
        .map((error, index) => (
          <div key={index} className="invalid-feedback">
            {error.message}
          </div>
        ))}
    </>
  );
};
